import React from 'react';

import Button from '@atlaskit/button/button';
import __noop from '@atlaskit/ds-lib/noop';
import CloseIcon from '@atlaskit/icon/core/cross';
// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import SpotlightCard from '@atlaskit/onboarding/spotlight-card';
import { token } from '@atlaskit/tokens';

const SpotlightCardHeadingAfterExample = (): React.JSX.Element => {
	return (
		<SpotlightCard
			headingAfterElement={
				<Button
					iconBefore={<CloseIcon label="Close" color={token('color.icon.inverse')} />}
					appearance="subtle"
				/>
			}
			heading="Switch it up"
			headingLevel={2}
			actions={[{ text: 'Next', onClick: __noop }]}
		>
			Select the project name and icon to quickly switch between your most recent projects.
		</SpotlightCard>
	);
};

export default SpotlightCardHeadingAfterExample;
